import { render } from "./HeroiconsOutlineCurrencyEuro.vue?vue&type=template&id=66945171"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyEuro.vue"]])

export default __exports__